import { render, staticRenderFns } from "./SuggestedFriends.vue?vue&type=template&id=19c7ea9a"
import script from "./SuggestedFriends.vue?vue&type=script&lang=js"
export * from "./SuggestedFriends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports